
import { defineComponent, ref, onBeforeUnmount } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'indexIndividualWeddingrings',
  props: {
    pageStr: {
      type: String,
      required: true,
    },
  },
  setup() {
    const moduleIndividualCurrentIndex = ref(0)

    const moduleIndividual: Array<object> = [
      {
        text: '',
        image: 'individual_weddingrings_ring_1',
      },
      {
        text: '',
        image: 'individual_weddingrings_ring_2',
      },
      {
        text: '',
        image: 'individual_weddingrings_ring_3',
      },
      {
        text: '',
        image: 'individual_weddingrings_ring_4',
      },
      {
        text: '',
        image: 'individual_weddingrings_ring_5',
      },
    ]

    const moduleIndividualHide = ref(false)
    const moduleIndividualShow = ref(true)

    const hideByTimeout = () => {
      setTimeout(function () {
        moduleIndividualHide.value = true
        moduleIndividualShow.value = false
      }, 1500)
    }

    hideByTimeout()

    const changeModuleIndividual = () => {
      moduleIndividualHide.value = false
      moduleIndividualShow.value = true

      hideByTimeout()

      moduleIndividualCurrentIndex.value++

      const lastElement = moduleIndividual.length - 1

      if (moduleIndividualCurrentIndex.value > lastElement) {
        moduleIndividualCurrentIndex.value = 0
      }
    }

    const setModuleIndividualItem = (index: number) => {
      clearInterval(moduleIndividualInterval)
      moduleIndividualCurrentIndex.value = index
      moduleIndividualHide.value = false
      moduleIndividualShow.value = true
    }

    const moduleIndividualInterval = setInterval(changeModuleIndividual, 3000)
    onBeforeUnmount(() => clearInterval(moduleIndividualInterval))

    if (process.client !== true) {
      clearInterval(moduleIndividualInterval)
    }
    return {
      moduleIndividual,
      moduleIndividualCurrentIndex,
      setModuleIndividualItem,
      moduleIndividualHide,
      moduleIndividualShow,
    }
  },
})
